(() => {
    let customizerCanvasForMerge = null;
    const productSection = {
        getPdpSwatch(position, optionValue) {
            return document.querySelector(
                `product-section [data-picker-fieldset][data-position="${position}"] input[value=${JSON.stringify(optionValue)}]`
            );
        },
        removeProductGalleryPreview() {
            document.querySelectorAll('[data-personalized-frame-gallery-preview]')
                .forEach(preview => preview.remove());
        },
        find(selector) {
            return document.querySelector(`product-section ${selector}`);
        },
        get activeGalleryElement() {
            const element = document.querySelector('media-gallery li.is-active');
            // In case something changes, and we can no longer find the first element,
            // we'll fall back to a hidden div so that other things don't break
            return element ? element : document.createElement('div');
        },
        get contentWrapper() {
            return document.querySelector('product-section [data-section-content]');
        },
        get productForm() {
            return document.querySelector('product-form');
        },
        get addToCartButton() {
            return productSection.productForm.querySelector('[name="add"]');
        },
        get variantPicker() {
            return productSection.productForm.querySelector('variant-picker');
        }
    };

    const addPreviewToGallery = (mergedImageUrl, variant, product) => {
        productSection.removeProductGalleryPreview();

        const html = BryanAnthonys.personalizedFramePreview.createMarkup(
            variant.getTitle(),
            document.getElementById('ProductCustomizer')
        );

        productSection.activeGalleryElement.insertAdjacentHTML('afterbegin', BryanAnthonys.htmlReviewedForSafety(BryanAnthonys.partiallySanitize(`
            <div 
                class="product-media-container global-media-settings personalized-frame-preview-pdp" 
                data-personalized-frame-gallery-preview style="--ratio-percent: 125%"
            >
                <personalized-frame-preview-opener 
                    class="product__modal-opener product__modal-opener--image"
                    data-product-handle="${product.getHandle()}" data-variant-title=${JSON.stringify(variant.getTitle())}
                >
                    <div class="product__media media product-media">
                        <div class="personalized-frame-preview-media">
                            ${html}
                        </div>
                    </div>
                </personalized-frame-preview-opener>
            </div>
        `)));

        productSection.find('[data-personalized-frame-preview-customer-image]').src = mergedImageUrl;
        productSection.find('personalized-frame-preview-opener').dataset.image = new URL(mergedImageUrl).toString();
    };

    document.addEventListener('frameBuilderInitFailed', event => {
        const personalizeButton = document.querySelector('product-section [data-modal="#ProductCustomizer"]');
        personalizeButton.classList.add('hidden');

        if (event.detail.configurationErrors.length) {
            personalizeButton.insertAdjacentHTML('afterend', `
                <div class="status-banner status-banner--error">
                    <h3 class="h4 height-150 uppercase letter-spacing-1">Oups, this product has an issue.</h3>
                    <p class="mb-0">Please contact customer support. Thank You 🙂</p>
                </div>
            `);
        } else {
            productSection.variantPicker.insertAdjacentHTML('afterend', `
                <div class="status-banner status-banner--error mb-3 w-100 mb-3">
                    <h3 class="h4 height-150 uppercase letter-spacing-1 mb-3">Your browser may be out of date</h3>
                    <p>It appears that the browser you are currently using does not support our online photo app.
                     To ensure the best experience, please consider using a modern browser. 
                     If you still wish to proceed, follow the steps below:</p>
                    <ol>
                        <li>Add the frame to your cart without personalizing it, and complete the order.</li>
                        <li>Contact us and provide a high-resolution photo that you would like to use in the frame.</li>
                    </ol>
                </div>
            `);

            productSection.contentWrapper.classList.add('customization-applied');
        }
    });

    // Swatches inside the product frame popup
    document.addEventListener('swatchButtonsVariantChanged', event => {
        if (!event.target.closest('product-frame-builder')) {
            return;
        }

        const options = event.detail.options;

        if (document.getElementById('ProductCustomizer').hasAttribute('open')) {
            for (const option in options) {
                const position = option.replace('option', '');
                productSection.getPdpSwatch(position, options[option]).click();
            }
        }

        if (event.detail.variant) {
            const builder = document.querySelector('product-frame-builder');

            if (parseInt(builder.dataset.variantId) !== parseInt(event.detail.variant.id)) {
                builder.dataset.variantId = event.detail.variant.id;

                productSection.contentWrapper.classList.remove('customization-applied');
            }
        }
    });

    // Swatches in the main product section
    document.addEventListener('productVariantChanged', event => {
        if (event.detail.variant) {
            const builder = document.querySelector('product-frame-builder');
            if (parseInt(builder.dataset.variantId) !== parseInt(event.detail.variant.id)) {
                builder.dataset.variantId = event.detail.variant.id;

                productSection.contentWrapper.classList.remove('customization-applied');

                productSection.productForm.querySelectorAll('[data-personalized-frames-text-props]')
                    .forEach(propWrapper => propWrapper.remove());

                const personalizationModal = document.getElementById('ProductCustomizer');
                if (!personalizationModal.hasAttribute('open')) {
                    const modalSwatch = personalizationModal.querySelector(
                        `swatch-group [data-value="${event.detail.variant.option1}"]`
                    );
                    if (modalSwatch) {
                        modalSwatch.click();
                    }
                }
            }
        }
    });

    document.addEventListener('createdFinalPrintImage', event => {
        const settings = document.querySelector('product-frame-builder').settings;
        const {mergedImageUrl, variant, product, customerText} = event.detail;

        // Add gallery preview
        document.querySelectorAll('modal-dialog[open], [data-inherits-from-modal][open]')
            .forEach(modal => modal.hide());
        addPreviewToGallery(mergedImageUrl, variant, product);

        // Display add to cart button
        productSection.contentWrapper.classList.add('customization-applied');

        // Frame customer text - add it as a cart item property
        if (customerText !== null) {
            productSection.productForm.querySelectorAll('[data-personalized-frames-text-props]')
                .forEach(propWrapper => propWrapper.remove());

            const customerTextString = customerText.join(' ')
                .replace(/</g, "")
                .replace(/>/g, "")
                .replace(/&/g, "&amp;")
                .replace(/"/g, "&quot;")
                .replace(/'/g, "&#039;");

            const confirmText = settings.getCustomerTextConfirm(customerText.length > 0);

            productSection.variantPicker.insertAdjacentHTML('afterend', BryanAnthonys.htmlReviewedForSafety(BryanAnthonys.partiallySanitize(`
                <div data-personalized-frames-text-props class="mb-3">
                  <input type="hidden" name="properties[Frame text]" value="" data-personalized-frame-text-confirm-property />
                  <label class="custom-checkbox" data-personalized-frame-text-confirm>
                    <input type="checkbox">
                    <span class="custom-checkbox__checkmark"></span>
                    <span class="custom-checkbox__text">
                        ${confirmText.replace('[text]', '<span data-customer-frame-text></span>')}
                    </span>
                  </label>
                </div>
            `)));

            const visibleCustomText = productSection.find('[data-personalized-frame-text-confirm] [data-customer-frame-text]');
            if (visibleCustomText) {
                visibleCustomText.textContent = customerTextString;
            }

            productSection.find('[data-personalized-frame-text-confirm-property]').value = customerTextString;

            productSection.find('[data-personalized-frame-text-confirm] [type="checkbox"]').addEventListener(
                'change',
                event => {
                    if (event.target.checked) {
                        document.querySelectorAll('[data-personalized-frame-text-confirm-error]')
                            .forEach(el => el.remove());
                    }
                }
            );
        }

        // Saving reference to the canvas used to merge the customer image and text with the original print source image
        customizerCanvasForMerge = event.detail.canvasForMerge;
    });

    function showConfirmationPreview(response) {
        const opener = document.createElement('span');
        opener.dataset.image = new URL(response.properties['Your Canvas Image']).toString();
        opener.dataset.variantTitle = response.variant_title;
        opener.dataset.productHandle = response.handle;
        BryanAnthonys.personalizedFramePreview.openModal(opener, true, true);
    }

    function confirmCustomFrameText(productForm) {
        productForm.querySelectorAll('[data-personalized-frame-text-confirm-error]').forEach(el => el.remove());

        const checkbox = productForm.querySelector('[data-personalized-frame-text-confirm] [type="checkbox"]');
        if (checkbox && !checkbox.checked) {
            checkbox.parentElement.insertAdjacentHTML(`afterend`, `
                <div class="error" data-personalized-frame-text-confirm-error>Please confirm the custom text checkbox above</div>
            `);

            checkbox.parentElement.classList.add('wiggle');
            setTimeout(() => checkbox.parentElement.classList.remove('wiggle'), 1000);

            return false;
        }

        return true;
    }

    function addPersonalizedFrameToCart(form, canvasImageBlob) {
        const productForm = form.closest('product-form');
        if (!canvasImageBlob) {
            productForm.showErrorMessage('Frame image is missing. Please try customizing the image again.');

            return;
        }

        if (productForm.submitButton.getAttribute('aria-disabled') === 'true') {
            return;
        }

        if (!confirmCustomFrameText(productForm)) {
            return;
        }

        productForm.hideErrorMessage();

        productForm.submitButton.setAttribute('aria-disabled', true);
        productForm.submitButton.classList.add('loading');

        const formData = new FormData(productForm.form);
        formData.append('properties[Your Canvas Image]', canvasImageBlob, 'customer_photo_frame.png');
        formData.append('sections', productForm.cart.getSectionsToRender().map(section => section.id).join(','));
        formData.append('sections_url', BryanAnthonys.pagePath());

        BryanAnthonys.cart.add(formData)
            .then(response => {
                productForm.cart.renderContents(response);
                setTimeout(() => showConfirmationPreview(response), 500);
                productSection.removeProductGalleryPreview();
                productSection.contentWrapper.classList.remove('customization-applied');
                document.querySelector('product-frame-builder').reset();
                productSection.productForm.querySelectorAll('[data-personalized-frames-text-props]')
                    .forEach(propWrapper => propWrapper.remove());
                if (productForm.cart.classList.contains('is-empty')) {
                    productForm.cart.classList.remove('is-empty');
                }
            })
            .catch(exception => {
                if (exception instanceof AjaxException) {
                    productForm.showErrorMessage(exception.description);
                } else {
                    console.error(exception);
                }
            })
            .finally(() => {
                productForm.submitButton.classList.remove('loading');
                productForm.submitButton.removeAttribute('aria-disabled');
            });
    }

    document.addEventListener('submit', event => {
        const form = event.target;
        if (form.dataset.type === 'add-to-cart-form' && form.closest('product-form')) {
            event.preventDefault();
            event.stopPropagation();
            customizerCanvasForMerge.toBlob(blob => addPersonalizedFrameToCart(form, blob), 'image/png');
        }
    });
})();